import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import React, { createContext, useContext, useState } from "react";

const PromptDialogContext = createContext(null);

export function usePrompt() {
  const context = useContext(PromptDialogContext);
  if (!context)
    throw new Error("usePrompt must be used within PromptDialogProvider");
  return context;
}

export function PromptDialogProvider({ children }) {
  const [dialogState, setDialogState] = useState({ open: false });
  const [resolver, setResolver] = useState(null);
  const [inputValue, setInputValue] = useState("");

  const prompt = ({
    message,
    title = "Digite uma informação",
    confirmText = "Confirmar",
    cancelText = "Cancelar",
    defaultValue = "",
  }) => {
    return new Promise((resolve) => {
      setInputValue(defaultValue);
      setDialogState({ open: true, message, title, confirmText, cancelText });
      setResolver(() => resolve);
    });
  };

  const handleClose = (result) => {
    setDialogState({ open: false });
    if (resolver) resolver(result);
  };

  return (
    <PromptDialogContext.Provider value={prompt}>
      {children}
      <Dialog
        slotProps={{
          paper: {
            sx: { minWidth: "25rem", minHeight: "10rem", padding: "0.5rem" },
          },
        }}
        open={dialogState.open}
        onClose={() => handleClose(null)}
      >
        <DialogTitle>{dialogState.title}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            sx={{ marginTop: "1rem" }}
            label={dialogState.message}
            margin="dense"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(null)}>
            {dialogState.cancelText}
          </Button>
          <Button onClick={() => handleClose(inputValue)} autoFocus>
            {dialogState.confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    </PromptDialogContext.Provider>
  );
}
